import { DIGIT_ASCIIS, LOWERCASE_ASCIIS, UPPERCASE_ASCIIS } from './Constants';

export const areAsciiNumbersComparable = (firstChar: number, secondChar: number) => {
  if (LOWERCASE_ASCIIS.includes(firstChar) && LOWERCASE_ASCIIS.includes(secondChar)) {
    return true;
  }
  if (UPPERCASE_ASCIIS.includes(firstChar) && UPPERCASE_ASCIIS.includes(secondChar)) {
    return true;
  }
  if (DIGIT_ASCIIS.includes(firstChar) && DIGIT_ASCIIS.includes(secondChar)) {
    return true;
  }
  return false;
};
